// Module
var code = "<react-component name=\"{{component}}\" props=\"props\"></react-component>\n";
// Exports
module.exports = code;